
import request from '@/utils/request';
import Vue from 'vue';
// 创建分类
export function visaApplicantIdentityCreate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visaApplicantIdentity/create`,
      data:params
    });
  }
// 删除 
export function visaApplicantIdentityDelete (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visaApplicantIdentity/delete/${params}`
    });
  }
//查询签证分类列表 
export function visaApplicantIdentityQuery (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visaApplicantIdentity/query`,
      data:params
    });
  }
// 修改
export function visaApplicantIdentityUpdate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visaApplicantIdentity/update`,
      data:params
    });
  }
//查询所有 
export function visaApplicantGetAllIdentity () {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/visaApplicantIdentity/getAllIdentity`
  });
}
